import { NavLink } from 'react-router-dom';
import Button from '../../common/Button/Button';
import s from './Times.module.scss';
import { ReactComponent as ShevronIcon } from '../../../aassets/ic/ui/ic_shevron_left_white.svg';
import { ReactComponent as IconRemove } from '../../../aassets/ic/timer/ic_remove.svg';
import { ReactNode, useState } from 'react';
import { SelectDomain } from '../../../types';
import Switch from '../../common/Switch/Switch';

interface Props {
	selectDoms: SelectDomain[];
	setSelectDoms: React.Dispatch<React.SetStateAction<SelectDomain[]>>;
	productID: number;
	isDemo: boolean;
	is_purchased: boolean;
	url?: string;
}
const Times = ({
	selectDoms,
	setSelectDoms,
	productID,
	isDemo,
	is_purchased,
	url,
}: Props) => {
	const getSelectedCatIds = () => {
		const catIds = selectDoms.reduce<number[]>((acc, d) => {
			d.categories.forEach((c) => {
				if (c.isChoosen) {
					acc.push(c.id);
				}
			});

			return acc;
		}, []);
		return catIds.join(',');
	};

	const getUrl = () => {
		let url = '';
		selectDoms.forEach((dom) => {
			dom.categories.forEach((cat) => {
				if (cat.isChoosen) {
					url += '_c:' + cat.id;
					if (Object.hasOwn(cat, 'subcategories')) {
						const scIds = new Array<number>();
						cat.subcategories.forEach((sc) => {
							if (sc.isChoosen) {
								scIds.push(sc.id);
							}
						});
						url += '-sc:' + scIds.join(',');
					}
				}
			});
		});
		return url;
	};

	const updateTimerValues = (
		value: string,
		domIndex: number,
		catInd: number,
		type: 'seconds' | 'minutes' | 'all'
	) => {
		let newValues = {
			...selectDoms[domIndex].categories[catInd].times.current,
		};
		let maxValues = {
			...selectDoms[domIndex].categories[catInd].times.max,
		};

		if (type === 'minutes') {
			newValues.minutes = value;
		} else if (type === 'seconds') {
			newValues.seconds = value !== '5' ? value : '05';
		} else {
			newValues = selectDoms[domIndex].categories[catInd].times.def;
		}
		const newNumValue = parseFloat(
			`${newValues.minutes}.${newValues.seconds}`
		);
		const maxNumValue = parseFloat(
			`${maxValues.minutes}.${maxValues.seconds}`
		);

		if (newNumValue <= maxNumValue) {
			const newDoms = [...selectDoms];
			newDoms[domIndex].categories[catInd].times.current = newValues;
			setSelectDoms(newDoms);
		}
	};

	const handleQuizLink = (e: React.MouseEvent<HTMLElement>) => {
		if (getSelectedCatIds().length === 0) {
			e.preventDefault();
		}
	};

	const getSelectedTimes = () => {
		const arr = [];
		for (let i = 0; i < selectDoms.length; i++) {
			for (let j = 0; j < selectDoms[i].categories.length; j++) {
				const time = selectDoms[i].categories[j].times.current;
				arr.push({
					category_id: selectDoms[i].categories[j].id,
					time: parseInt(time.minutes) * 60 + parseInt(time.seconds),
				});
			}
		}
		return arr;
	};

	const timers = selectDoms.reduce<ReactNode[]>((dacc, d, ind) => {
		const elems = d.categories.reduce<ReactNode[]>((acc, c, i) => {
			if (c.isChoosen) {
				acc.push(
					<div className={s.timer} key={`ttimer${i}`}>
						<label
							className={s.timer_lbl}
							htmlFor={`timer:${c.id}`}>
							{c.name}
						</label>
						<div className={s.timer_inputs}>
							<input
								id={`timer:${i}`}
								type="number"
								name="t_timer"
								className={s.timer_inpM}
								max={59}
								min={0}
								step={5}
								value={c.times.current.seconds}
								disabled={isDemo}
								onChange={(e) =>
									isDemo
										? () => {}
										: updateTimerValues(
												e.target.value,
												ind,
												i,
												'seconds'
										  )
								}
							/>
							<span className={s.timer_separ}>:</span>
							<input
								id={`timer:${i + 1}`}
								type="number"
								name="t_timer"
								className={s.timer_inpH}
								max={9}
								min={0}
								value={c.times.current.minutes}
								disabled={isDemo}
								onChange={(e) =>
									isDemo
										? () => {}
										: updateTimerValues(
												e.currentTarget.value,
												ind,
												i,
												'minutes'
										  )
								}
							/>
						</div>
						<button
							onClick={() => {
								updateTimerValues('', ind, i, 'all');
							}}
							className={s.timer_btn_remove}>
							<IconRemove />
						</button>
					</div>
				);
			}
			return acc;
		}, []);
		dacc.push(elems);
		return dacc;
	}, []);

	const [dontUseTimes, setDontUseTimes] = useState(false);

	return (
		<div className={s.rt}>
			<h2 className={s.h2}>קבע זמני תרגול</h2>
			<div className={s.timer_header}>
				<div className={s.timer_title_1}>שם התרגול</div>
				<div className={s.timer_title_2}>זמן לשאלה</div>
			</div>
			{timers}
			<div className={s.bottom}>
				<Switch
					id="dontUseTimes"
					lbl="תרגול ללא הגבלת זמן"
					isOn={dontUseTimes}
					isWide
					customClass={s.switch}
					updateState={() => setDontUseTimes(!dontUseTimes)}
				/>
				{is_purchased || isDemo ? (
					<NavLink
						to={`/quiz/${productID}/${getUrl()}`}
						state={{
							times: getSelectedTimes(),
							useTimes: !dontUseTimes,
						}}>
						<Button
							isWithIcon
							color="yellow"
							fillMode="fill"
							width={'full'}
							onClick={handleQuizLink}>
							{getSelectedCatIds().length > 0
								? 'התחל לתרגל'
								: 'נא לבחור נושאים'}
							<ShevronIcon />
						</Button>
					</NavLink>
				) : (
					<a href={url} className={s.link}>
						<Button
							isWithIcon
							color="yellow"
							fillMode="fill"
							width={'full'}>
							לרכישה
							<ShevronIcon />
						</Button>
					</a>
				)}
			</div>
		</div>
	);
};
export default Times;
